import { APIQuery } from "./api.base";
import { APIResponse } from "../types/api.types";

export const members = async (id: number, offset: number, limit: number): Promise<APIResponse> => {
    return await APIQuery(`/association/members/?offset=${offset}&limit=${limit}`, 'GET', []);
};

export const invitationResend = async (association_id: string, email: string): Promise<APIResponse> => {
    return await APIQuery('/user/invitation/resend', "POST", [{ name: "x-association-id", value: association_id }], { email: email });
};

export const invitationsDelete = async (association_id: string, email: string): Promise<APIResponse> => {
    return await APIQuery('/user/invitation/delete', "POST", [{ name: "x-association-id", value: association_id }], { email: email });
};
